import { useEffect, useState } from "react";

const LOGO_URL = "/criye-logo.png";

export default function SplashScreen() {
  const [visible, setVisible] = useState(() => {
    if (typeof window === "undefined") return true;
    return !sessionStorage.getItem("criye_splash_seen");
  });
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    if (!visible) return;
    const fadeTimer = setTimeout(() => setFadeOut(true), 2200);
    const removeTimer = setTimeout(() => {
      setVisible(false);
      try { sessionStorage.setItem("criye_splash_seen", "1"); } catch {}
    }, 2800);
    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(removeTimer);
    };
  }, [visible]);

  if (!visible) return null;

  return (
    <div
      data-testid="splash-screen"
      className={`fixed inset-0 z-[100] flex items-center justify-center bg-[#050505] transition-opacity duration-500 ${
        fadeOut ? "opacity-0 pointer-events-none" : "opacity-100"
      }`}
      aria-hidden={fadeOut}
    >
      {/* Background glow */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute left-1/2 top-1/2 h-[700px] w-[700px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-turquoise/10 blur-[140px] splash-pulse" />
        <div className="absolute left-1/2 top-1/2 h-[350px] w-[350px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-cyan-500/15 blur-[80px] splash-pulse-slow" />
      </div>

      {/* Subtle grid */}
      <div
        className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(0,255,212,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(0,255,212,0.5) 1px, transparent 1px)",
          backgroundSize: "40px 40px",
        }}
      />

      {/* Logo + Text */}
      <div className="relative flex flex-col items-center splash-fade-in">
        {/* 3D rotating logo */}
        <div className="splash-perspective">
          <div className="splash-rotate-3d">
            <img
              src={LOGO_URL}
              alt="CRIYE"
              className="w-52 h-52 md:w-64 md:h-64 object-contain"
              style={{
                filter:
                  "drop-shadow(0 0 25px rgba(0,255,212,0.6)) drop-shadow(0 0 50px rgba(0,176,255,0.4)) drop-shadow(0 10px 20px rgba(0,0,0,0.5))",
              }}
              draggable="false"
            />
          </div>
        </div>

        {/* CRIYE brand text */}
        <h1
          className="mt-6 text-5xl md:text-6xl font-heading font-bold tracking-[0.2em] splash-text-glow"
          style={{
            background:
              "linear-gradient(135deg, #00FFD4 0%, #00B0FF 50%, #00FFD4 100%)",
            backgroundSize: "200% 200%",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            textShadow: "0 0 40px rgba(0,255,212,0.3)",
          }}
        >
          CRIYE
        </h1>
        <p className="mt-2 text-[10px] md:text-xs uppercase tracking-[0.5em] text-turquoise/70 font-mono">
          Control Interno
        </p>
      </div>

      <style>{`
        @keyframes splash-pulse-key {
          0%, 100% { opacity: 0.5; transform: translate(-50%, -50%) scale(1); }
          50% { opacity: 1; transform: translate(-50%, -50%) scale(1.08); }
        }
        @keyframes splash-fade-in-key {
          0% { opacity: 0; transform: translateY(10px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        @keyframes splash-rotate-3d-key {
          0% { transform: rotateY(0deg); }
          100% { transform: rotateY(360deg); }
        }
        @keyframes splash-text-shimmer {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }
        .splash-pulse {
          animation: splash-pulse-key 2.4s ease-in-out infinite;
        }
        .splash-pulse-slow {
          animation: splash-pulse-key 3.2s ease-in-out infinite;
          animation-delay: 0.3s;
        }
        .splash-fade-in {
          animation: splash-fade-in-key 0.6s ease-out forwards;
        }
        .splash-perspective {
          perspective: 1200px;
          perspective-origin: center center;
        }
        .splash-rotate-3d {
          transform-style: preserve-3d;
          animation: splash-rotate-3d-key 2.8s cubic-bezier(0.45, 0, 0.55, 1) infinite;
          will-change: transform;
        }
        .splash-text-glow {
          animation: splash-text-shimmer 2.5s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
}
